import firebase from 'firebase/app';

export const makeMeMember = (company, id) => {

    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(id)
        .update({
            role: 'member'
        })
}

export const makeMeAdmin = (company, id) => {

    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(id)
        .update({
            role: 'admin'
        })
}